module.exports = __webpack_public_path__ + "static/img/doudizhu2.9e6c88d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/doudizhu2.jpg
// module id = MIBB
// module chunks = 0